import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";

export const useTracking = () => {
  const trackClick = (
    aiEngineRecommendId: string,
    entityId: string,
    destinationUrl: string,
    index: string,
  ) => {
    sendGATracking({
      action: `Top Picks/inHouse/${aiEngineRecommendId}/Click` as const,
      category: "Top Picks",
      label: entityId,
    });

    sendGA4Tracking({
      action: "click",
      category: "recirculation",
      customized_parameters: {
        article_id: entityId,
        article_seq: index,
        destination_url: destinationUrl,
        page_type: "article",
        recommendation_id: aiEngineRecommendId,
        widget_name: "top_picks",
      },
      subcategory: "widget",
    });
  };

  return {
    trackClick,
  };
};
